declare global {
  interface Window {
    _headerSpacingTimeout?: number;
  }
}

export default function initHeaderSpacing(): void {
    const mainHeader = document.querySelector('.main-header') as HTMLElement | null;
    const headerArchive = document.querySelector('.header-archive') as HTMLElement | null;
    const headerSingle = document.querySelector('.header-single') as HTMLElement | null;
    const blockHeader = document.querySelector('.block-header') as HTMLElement | null;

    if (!mainHeader) return;

    const applySpacing = () => {
        const height = mainHeader.clientHeight;
        new HeaderSpacing(headerArchive, height);
        new HeaderSpacing(headerSingle, height);
        new HeaderSpacing(blockHeader, height);
    };

    applySpacing();

    window.addEventListener('resize', () => {
        if (window._headerSpacingTimeout) {
            clearTimeout(window._headerSpacingTimeout);
        }
        window._headerSpacingTimeout = window.setTimeout(applySpacing, 100);
    });
}

class HeaderSpacing {
    $el: HTMLElement | null;
    height: number;

    constructor($el: HTMLElement | null, height: number) {
        this.$el = $el;
        this.height = height;
        this.init();
    }

    init(): void {
        if (!this.$el) return;
        this.$el.style.paddingTop = `${this.height}px`;
    }
}
